import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsappChatIcon.scss"; // Import SCSS file

const WhatsappChatIcon = () => {
  const whatsappNumber = "918527730069"; // Correct WhatsApp number
  const message = encodeURIComponent("Hello, I need some assistance!");

  return (
    <div className="whatsapp-container">
      {/* Popup message always visible */}
      <div className="whatsapp-popup">How can we help you today?</div>
      
      <a
        href={`https://wa.me/${whatsappNumber}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-icon"
      >
        <FaWhatsapp size={40} />
      </a>
    </div>
  );
};

export default WhatsappChatIcon;
